import React, { useState, useEffect } from 'react';
import moment from 'moment';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCategoryFilter from 'components/organisms/NewCategoryFilter';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import StatisticsGraph from './StatisticsGraph';

const Statistics = ({ switchDatas, graphType }) => {
  const initParams = {
    type: '01',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const initLoading = true;
  const [loading, setLoading] = useState(initLoading);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setLoading(true);
      setParams(newParams);
    }
  };

  const handleGraphStatus = (status) => {
    if (!!status) {
      setLoading(false);
    }
  };

  return (
    <>
      <NewFilterWrap loading={loading} handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
        />
        <NewCategoryFilter params={params} getParam={getParam} />
      </NewFilterWrap>
      <StatisticsGraph
        graphType={graphType}
        switchDatas={switchDatas}
        params={params}
        handleGraphStatus={handleGraphStatus}
      />
    </>
  );
};

export default Statistics;
